import reduxStore from './../../../reduxStore';

export const ADD_NEW_CATEGORY_SET_MESSAGE = 'ADD_NEW_CATEGORY_SET_MESSAGE';
export const ADD_NEW_CATEGORY_RESET_TO_INITIAL = 'ADD_NEW_CATEGORY_RESET_TO_INITIAL';

const actions = {

    resetToInitialState: () => {
        reduxStore.dispatch({
            type: ADD_NEW_CATEGORY_RESET_TO_INITIAL
        });
    },

    setAddNewCategoryMessage: (messageId) => {
        reduxStore.dispatch({
            type: ADD_NEW_CATEGORY_SET_MESSAGE,
            payload: messageId
        });
    }

};

export default actions;


// WEBPACK FOOTER //
// ./src/scripts/reusable/ReusableModals/AddNewCategoryModal/AddNewCategoryModal.actions.js